export default {
  myAccount: {
    myAccount: 'アカウント',
    nickName: 'ニックネーム',
    nickNamePlaceholder: 'ニックネームを入力してください',
    birthdayPlaceholder: '日付を選択してください',
    birthday: 'お誕生日',
    emailSubscribe: 'メルマガご購読しますか',
    uid: 'アカウントID',
    nicknameValidFail: "特殊記号がご利用できません"
  },
  myOrder: {
    myOrder: '注文履歴',
    payEndTime: "お支払期限 ",
    allOrder: '全ての注文',
    pendingPaymentOrder: '支払待',
    todoOrder: '処理待',
    shippedOrder: '商品待',
    doneOrder: '注文完了',
    orderDate: '注文時間',
    orderNo: '注文番号',
    orderPayDate: '支払時間残り',
    orderCancel: '注文キャンセル',
    orderCancelSuccess: 'キャンセルしました',
    orderDetail: '注文詳細',
    orderExpress: '配送状況確認',
    orderAllProduct: '全ての商品',
    orderPayment: '支払方法',
    orderPayTips: '支払方法',
    orderPaymentTips: '{date}以内でお支払いを完了してください。',
    orderPaymentNoPay: '支払期限切',
    addressTitle: 'お届け先情報',
    addressUserName: 'お届け先',
    address: '住所詳細',
    addressPost: '郵便番号',
    addressTel: '電話番号',
    remarks: 'コメント',
    productTitle: '商品情報',
    deliveryNum: '宅急便{num}件',
    channelDate: '配達時間指定',
    delivery: '便',
    noOrder: '注文がありません',
    orderExpressTitle: "追跡情報",
    cancelTips: "注文キャンセル後、戻すことができません。続きますか。",
    cancelBtn1: "キャンセル",
    cancelBtn2: "閉じる",
    orderPointsTips: "注文完了後獲得予定ポイント数",
    productTotal: "商品小計",
    expressFree: "運賃",
    serviceFree: "代引手数料",
    promotionFree: "キャンペン",
    couponFree: "クーポン",
    pointsFree: "ポイント利用",
    totalFree: "合計金額",
    productCode: '商品ｺｰﾄﾞ',
    productOptionName: '規格',
    productNum: '数量',
    productReturn: '返品交換',
    productReturnDetail: '返品交換詳細',
    alteration: '変更',
    package: '箱',
    noExpressInfo: '送り状情報がありません',
    reBuy: "再度購入"
  },
  myCoupon: {
    myCoupon: 'Myクーポン',
    derate: '{num} OFF',
    discount: '折扣',
    unconditional: '0円以上利用可能',
    useCondition: '{money}円以上利用可能',
    usefulLife: '使用期限：',
    freeTransport: '送料無料',
    commodityCoverage: '適用範囲：',
    allProductUse: '全ての商品',
    portionProductUse: '指定商品',
    portionProductCanNotUse: '指定商品',
    freeTransportArea: '送料無料エリア：',
    allArea: '全てのエリア',
    except: 'が対象外',
    immediateUse: 'すぐ使用',
    usable: '利用可',
    used: '使用済',
    overdue: '期限切',
    noCoupon: '現在利用可能なクーポンがありません',
    getNow: 'すぐ登録',
    limitGet: '登録制限：',
    unit: '枚',
    couponUseTimePrompt1: '登録当日から{time}日内',
    couponUseTimePrompt2: '登録翌日から{time}日内',
    freeTransportCoupon: '送料無料クーポン',
    useCondition1: '{num} 以上',
    useCondition2: '利用可能'
  },
  productEvaluationList: {
    productEvaluationList: '商品レビュー',
    predictPointPrompt: 'レビューを投稿したら、<span class="predictPointPrompt">{point} ポイント</span>を獲得できます。',
    awardedPointPrompt: '<span class="awardedPointPrompt">{point} ポイント</span>獲得済',
    immediateEvaluation: 'レビューを書く',
    orderDate: '注文時間',
    noEvaluation: 'レビュー待',
    haveEvaluation: 'レビュー済',
    noEvaluationPh: '暫無待評價商品',
    haveEvaluationPh: '暫無已評價商品',
    evaluationDetail: 'レビュー詳細',
    productScore: 'あなたの評価',
    yourEvaluation: '商品レビュー',
    pleaseInputYourEvaluation: '商品レビューを入力してください',
    pictureComment: '写真を投稿',
    uploadPicture: 'ｱｯﾌﾟﾛｰﾄﾞ',
    submitEvaluation: '投稿する',
    haveEvaluationPrompt: 'レビュー済、<span class="haveEvaluationPrompt">{point} ポイント</span>を獲得予定です',
    evaluationDate: 'レビュー時間',
    pictureNumPrompt: 'アップロード済 <span class="pictureNumPrompt">{number1}</span> 枚, <span class="pictureNumPrompt">{number2}</span> 枚までアップロード可能',
    allProductHaveEvaluation: 'この注文の商品がすべてレビューしました',
    star_null: 'レビュー点数を付けてください',
    evaluation_error: '5〜200文字を入力してください'
  },
  myPoint: {
    myPoint: 'Myポイント',
    myPointTotal: '所有ポイント数',
    aboutToExpirePointNumber: '今月末まで有効なポイント数',
    addDate: "獲得日付",
    incomingsOutgoings: '獲得/使用',
    dueDate: "有効期限",
    explain: "説明"
  },
  productReturnList: {
    productReturnList: '返品交換',
    product: '商品',
    applicationDate: '申請時間',
    type: '区分',
    status: 'ステータス',
    returnedGoods: '返品',
    exchangeGoods: '交換',
    returnAmount: '数量',
    inProgress: '処理中',
    Processed: '処理済',
    orderInfo: '注文情報',
    orderNo: '注文番号',
    orderDate: '注文日付',
    productInfoAndReason: '商品情報',
    returnType: "区分",
    returnReason: "返品交換の理由",
    returnReason1: '商品が届いていません',
    returnReason2: '注文と異なる商品が届きました',
    returnReason3: '誤って注文しました',
    returnReason4: '商品品質の問題、賞味期限切れ',
    returnReason5: 'その他の理由をご説明ください',
    productUnsealing: '商品が開封済ですか',
    remark: '備考',
    amount: '数量',
    returnPrompt: '本サービスを利用することにより、利用規約に同意することになります。',
    shoppingTerms: '返品交換規約',
    productReturnApply: '返品交換申請',
    productReturnDetail: '返品交換詳細',
    applyReason: '申請理由',
    serviceAnswer: "カスタマーサポート",
    submitSuccess: "送信しました"
  },
  addressManagement: {
    addressManagement: 'アドレス帳',
    addAddress: '新しい住所登録',
    editAddress: '住所変更',
    country: "国",
    postcode: '郵便番号',
    postcodePh: '郵便番号を入力してください',
    area: '新しい住所',
    detailedAddress: '住所',
    consigneeName: 'お届け先名',
    consigneeNamePh: 'お届け先名を入力してください',
    consigneeNameValidFail: '特殊記号のご利用ができません',
    phone: '電話番号',
    phonePh: '電話番号を入力してください',
    phoneErr: '電話番号を正しく入力してください',
    operation: '操作',
    setDefault: '既定にする',
    defaultAddress: '既定住所',
    setDefaultaddAddress: '既定住所に設定',
    address1: '都道府県',
    address2: '市区町村',
    address3: '詳細住所（丁目·番地·建物名·部屋·番号）',
    address3Ph: '詳細住所を入力してください',
    address3w: '特殊記号のご利用はできません',
    postcodeAutoMatch: '自動入力',
    deleteAddress: 'アドレス削除',
    deleteAddressPrompt: "削除しますか?",
    postcodeError: '郵便番号が存在しません',
    townPlaceholder: '市区町村を選択してください',
    noAddress: 'アドレスがありません'
  },
  myCollect: {
    myCollect: '気に入り',
    cancelCollect: '削除'
  },
  memberCenter: {
    logout: 'ログアウト',
    memberCenter: 'Myページ',
    editEmail: 'メールアドレス',
    editPhone: '携帯番号',
    updatePwd: 'パスワード変更',
    newPwd: '新しいパスワード',
    newPwdNull: '新しいパスワードを入力してください',
    oldPwd: '現在のパスワード',
    oldPwdNull: '現在のパスワードを入力してください',
    pleaseChangeEmail: '登録中のメールアドレスと同じです。メールアドレスが変更されていません',
    pleaseChangePhone: '登録中の携帯番号と同じです。携帯番号が変更されていません',
    logoutSuccess: 'ログアウトしました'
  }
};